<!-- 整数数字输入框:包括0 -->
<script>
import { Input } from 'element-ui';

export default {
    name: 'ElIntegerInput',
    extends: Input,
    watch: {
        value() {
            this.transNum();
            // this.phoneAutoCompleteHandle();
        },
    },
    methods: {
        // 转换值：浮点数限制
        transNum() {
            // 清除“数字”和“-”以外的字符
            if (this.value) {
                const res = this.value.toString().replace(/[^\d-]/g, '');
                this.$emit('input', res);
                this.$nextTick(this.setNativeInputValue);
            }
        },
    },
    mounted() {
        const inputDom = this.$refs.input;
        inputDom.onkeydown = function (ev) {
            ev.stopPropagation();
            const code = ev.keyCode;
            // console.log(code);
            if ((code >= 48 && code <= 57) || (code >= 96 && code <= 105) || (code === 8 || code === 46 || code === 37 || code === 39 || code === 109 || code === 229)) return true;
            return false;
        };
    },
};
</script>
